define( '../src/sublayouts/m22-box/m22-box',[ 'jquery', 'lib/utils' ], function ( $, utils ) {
    'use strict';

    var M22_BOX= function ( $component ) {

        this.$component = $component;

        return this;
    };

    M22_BOX.prototype.init = function () {
        var _this = this,
            boxItems = this.$component.find('.m22-box-item');


        _this.setBox(boxItems.length)

        this.$component.on('change',function(){
            _this.setBox(boxItems.length)
        })

        $(window).on('resize orientationchange', function(){
            boxItems = _this.$component.find('.m22-box-item');
            if (utils.breakpoint() === 'l' || utils.breakpoint() === 'm') {
                _this.setBox(boxItems.length)
            }
        });
        
    };

    M22_BOX.prototype.setBox = function(num) {
        var _this = this,
        className = 'm22-col'+ num;
        if(num === 1){
            this.$component.removeAttr('class');
            this.$component.addClass('m22-box')
            this.$component.addClass('m22-col1')
        }else{
            this.$component.removeAttr('class');
            this.$component.addClass('m22-box')
            this.$component.addClass('m22-cols')
            this.$component.addClass(className)
        }
    }


    return M22_BOX;

} );

